import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import DateFormat from "../../../components/DateFormat";

const ReplaysRBR = () => {
  const { typeUser } = useIsAdmin();
  document.title = "LVF1 - Replays RBR";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [replays, setReplays] = useState([]);
  const [selectedReplays, setSelectedReplays] = useState<string[]>([]);
  const [update, setUpdate] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getReplays`,
        {
          params: {
            driver: user,
          },
        },
      )
      .then(({ data }) => {
        setReplays(data.races);
        setShowDownload(data.showDownload);
      })
      .catch(({ response }) => {
        console.log(response);
        throw new Error(response);
      });
  }, [update]);

  const downloadZip = () => {
    const url = `${
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500"
    }/api/admin/downloadReplays`;

    axios
      .post(url, selectedReplays, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/zip" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", "replays.zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Error al descargar ZIP:", error.response || error);
      });
  };

  const deleteFiles = () => {
    if (token == null) return;
    const url = `${
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500"
    }/api/admin/deleteReplays`;
    axios
      .post(url, {
        selectedReplays,
        user,
        token: JSON.parse(token).token,
      })
      .then((response) => {
        toast.success("Replays deleted succesfully");
        setUpdate(!update);
      })
      .catch((error) => {
        console.error("Error al descargar ZIP:", error.response || error);
      });
  };

  const handleSelectAllDrivers = () => {
    setSelectedReplays((prev: string[]) => {
      const allLaps: string[] = [];

      replays.forEach((replay: any) => {
        replay.laps.forEach((lap: any) => {
          allLaps.push(lap.name);
        });
      });

      const allSelected = allLaps.every((lapName) => prev.includes(lapName));

      if (allSelected) {
        // deseleccionar todos
        return prev.filter((lapName) => !allLaps.includes(lapName));
      } else {
        // seleccionar todos
        const newSelected = [...prev];
        allLaps.forEach((lapName) => {
          if (!newSelected.includes(lapName)) {
            newSelected.push(lapName);
          }
        });
        return newSelected;
      }
    });
  };

  const handleCheckboxGral = (driver: string) => {
    setSelectedReplays((prev: string[]) => {
      // buscar todos los laps que empiecen por el driver
      const lapsOfDriver: string[] = [];
      replays.forEach((replay: any) => {
        replay.laps.forEach((lap: any) => {
          if (lap.name.startsWith(`rsf_${driver}`)) {
            lapsOfDriver.push(lap.name);
          }
        });
      });

      // comprobar si TODOS ya están seleccionados
      const allSelected = lapsOfDriver.every((lapName) =>
        prev.includes(lapName),
      );

      if (allSelected) {
        // si ya están todos -> deseleccionarlos
        return prev.filter((lapName) => !lapsOfDriver.includes(lapName));
      } else {
        // si falta alguno -> añadir los que no estén
        const newSelected = [...prev];
        lapsOfDriver.forEach((lapName) => {
          if (!newSelected.includes(lapName)) {
            newSelected.push(lapName);
          }
        });
        return newSelected;
      }
    });
  };

  const toggleReplayDone = () => {
    if (token == null) return;
    const url = `${
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500"
    }/api/admin/doneReplay`;
    axios
      .post(url, {
        selectedReplays,
        user,
        token: JSON.parse(token).token,
      })
      .then((response) => {
        toast.success("Replays marked as done succesfully");
        setUpdate(!update);
      })
      .catch((error) => {
        console.error("Error al descargar ZIP:", error.response || error);
      });
  };

  if (!(typeUser == 2 || typeUser == 5)) return <ErrorPage />;
  return (
    <div className="full-height padding-xl app-container flex-center-top page-transition">
      <div className="form-container-md">
        <Title text="Replays RBR" />
        <small className="mandatory-fields">(*) Required fields</small>
        <div className="text-center">
          <div id="replays-container">
            {replays.map((replay: any) => (
              <div
                className={`replayItem ${replay.done ? "replay-done" : ""}`}
                key={replay.name}
              >
                <label>
                  <input
                    type="checkbox"
                    checked={replay.laps.every((lap: any) =>
                      selectedReplays.includes(lap.name),
                    )}
                    onChange={() => handleCheckboxGral(replay.driver)}
                  />{" "}
                  <b>{replay.driver}</b>
                </label>
                <DateFormat
                  date={replay.laps[0].date}
                  format="full"
                ></DateFormat>
                <label>
                  <i>{replay.laps.length / 2} replays</i>
                </label>
              </div>
            ))}
          </div>
          <div className="space-around">
            <p>
              TOTAL: <b>{replays.length}</b> REPLAYS
            </p>
            {showDownload && (
              <>
                <Button variant="secondary" onClick={handleSelectAllDrivers}>
                  Select All
                </Button>
                <Button variant="primary" onClick={downloadZip}>
                  Download Files
                </Button>
                <Button variant="success" onClick={toggleReplayDone}>
                  Mark as done
                </Button>
                <Button variant="danger" onClick={deleteFiles}>
                  Delete Files
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplaysRBR;
